export const AXIOS_BASE_URL = 'https://goose-track-gr25.onrender.com/api';
// export const AXIOS_BASE_URL = 'http://localhost:8080/api';
